import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

const ContactInformationSection = ({
  profileData,
  setProfileData,
  userInfo,
  setUserInfo,
  showTitle = true,
}) => {
  return (
    <>
      {showTitle && (
        <div className="sm:col-span-6">
          <h2 className="text-xl font-medium">Contact Information</h2>
        </div>
      )}

      <div className="sm:col-span-3">
        <label htmlFor="email-address" className="block text-sm/6 font-medium">
          Email address
        </label>
        <input
          id="email-address"
          name="email-address"
          value={profileData?.email || ''}
          onChange={(event) =>
            setProfileData((prev) => ({ ...prev, email: event.target.value }))
          }
          type="text"
          autoComplete="email"
          className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base border border-gray-300 placeholder:text-gray-400 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none sm:text-sm/6"
        />
      </div>

      <div className="sm:col-span-3">
        <label htmlFor="phone-number" className="block text-sm/6 font-medium">
          Phone number
        </label>
        <input
          id="phone-number"
          name="phone-number"
          value={profileData?.phone_number || ''}
          onChange={(event) =>
            setProfileData((prev) => ({
              ...prev,
              phone_number: event.target.value,
            }))
          }
          type="text"
          autoComplete="tel"
          className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base border border-gray-300 placeholder:text-gray-400 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none sm:text-sm/6"
        />
      </div>

      {/* <div className="sm:col-span-3">
        <label htmlFor="country" className="block text-sm/6 font-medium">
          Country
        </label>
        <div className="mt-2 grid grid-cols-1">
          <select
            id="country"
            name="country"
            value={userInfo?.country || 'United Kingdom'}
            onChange={(event) =>
              setUserInfo((prev) => ({ ...prev, country: event.target.value }))
            }
            autoComplete="country-name"
            className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 border border-gray-300 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none sm:text-sm/6"
          >
            <option>United Kingdom</option>
            <option>France</option>
            <option>Spain</option>
          </select>
          <FontAwesomeIcon
            icon={faChevronDown}
            className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
          />
        </div>
      </div>

      <div className="sm:col-span-3">
        <label htmlFor="language" className="block text-sm/6 font-medium">
          Language
        </label>
        <input
          id="language"
          value={userInfo?.language || ''}
          onChange={(event) =>
            setUserInfo((prev) => ({ ...prev, language: event.target.value }))
          }
          name="language"
          type="text"
          className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base border border-gray-300 placeholder:text-gray-400 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none sm:text-sm/6"
        />
      </div> */}
    </>
  )
}

export default ContactInformationSection
